/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-unused-vars */
import * as React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import "./Dasboard.css";
import { GrClose } from "react-icons/gr";
import { Menu, MenuItem } from "@mui/material";
import Routing from "../../Routing";
import { useEffect } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
} from "../../Constant/Global";
import axios from "axios";
import { useState } from "react";

const drawerWidth = 240;

const formatDateTime = (dateTime) => {
  const date = new Date(dateTime);

  const dateOptions = {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  const timeOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-US", dateOptions);
  const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

  return `${formattedDate}, ${formattedTime}`;
};

export default function ResponsiveDrawer(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const hideClasses = location.pathname === "/login";
  const isPrintPage = location.pathname === "/user_details";
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [allOpen, setAllOpen] = React.useState(false);
  const [Open, setOpen] = React.useState(false);
  const [masterOpen, setMasterOpen] = React.useState(false);
  const [simCardOpen, setSimCardOpen] = React.useState(false);
  const [catOpen, setCatOpen] = React.useState(false);
  const [productOpen, setProductOpen] = React.useState(false);
  const [PagesOpen, setPagesOpen] = React.useState(false);
  const [slideOpen, setSlideOpen] = React.useState(false);
  const [faqOpen, setFaqOpen] = React.useState(false);
  const [portfolioOpen, setPortfolioOpen] = React.useState(false);

  const [DeliveryScheduleOpen, setDeliveryScheduleOpen] = React.useState(false);
  const [DeliveryBoyOpen, setDeliveryBoyOpen] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState("item1");
  const navigate = useNavigate("");
  const [currentDateTime, setCurrentDateTime] = React.useState(new Date());
  const [selectedImage1, setSelectedImage1] = useState(null);

  const userDetails = sessionStorage.getItem("info");
  const useInfo = JSON.parse(userDetails);

  const formattedDateTime = formatDateTime(currentDateTime);

  const [day, rest] = formattedDateTime.split(", ", 1);
  const restDateTime = formattedDateTime.slice(day.length + 2);

  // logo for admin
  useEffect(() => {
    const handleGetDetailsById = async () => {
      const user_id = useInfo?.id;
      try {
        const response = await axios.get(
          API_BASE_URL + `admin/profile/${user_id}`,
          {
            auth: {
              username: API_AUTH_USERNAME,
              password: API_AUTH_PASSWORD,
            },
          }
        );
        if (response.data.status) {
          if (response.data.data.image) {
            setSelectedImage1(response.data.data.image);
          }
        }
      } catch (error) {
        console.log("error occured getting data", error);
      }
    };
    handleGetDetailsById();
  }, [useInfo?.id]);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("info") === null) {
      console.log("please login first");
      navigate("/login");
    }
  }, []);

  const handleCloseProfile = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("info");
    setAnchorEl(null);
    navigate("/login");
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCloseMenu = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClick = (item) => {
    setActiveItem(item);
  };
  const drawer = (
    <div
      style={{
        paddingBottom: "5rem",
        backgroundColor: "rgb(47 47 145)",
        display: isPrintPage ? "none" : "",
      }}
    >
      <style>
        {`
        /* Style the scrollbar */
        ::-webkit-scrollbar {
          width: 1px;
        }

        
      `}
      </style>
      <Toolbar
        className="ps-0 d-flex justify-content-between align-items-center"
        sx={{ height: "40px" }}
        style={{ backgroundColor: "rgb(47 47 145)" }}
      >
        <div className="d-flex justify-content-center w-100">
          <Link className="admin-logo-sec" to="/">
            <img
              className="admin-logo"
              src={selectedImage1 !== null && selectedImage1}
              alt=""
            />
          </Link>
        </div>
        <button className="close_menu_btn" onClick={handleCloseMenu}>
          <GrClose color="#625C5C" />
        </button>
      </Toolbar>
      <Divider></Divider>
      <List>
        <Link to="/" className="link_tag">
          <ListItem
            className={location.pathname === "/" ? "active" : "bg_dashboard"}
            onClick={() => handleClick("item1")}
            disablePadding
          >
            {" "}
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                {/* <GridViewIcon /> */}
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333ZM7.5 15.8333H4.16667V12.5H7.5V15.8333ZM16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5ZM15.8333 7.5H12.5V4.16667H15.8333V7.5ZM16.6667 13.3333H15V11.6667C15 11.4457 14.9122 11.2337 14.7559 11.0774C14.5996 10.9211 14.3877 10.8333 14.1667 10.8333C13.9457 10.8333 13.7337 10.9211 13.5774 11.0774C13.4211 11.2337 13.3333 11.4457 13.3333 11.6667V13.3333H11.6667C11.4457 13.3333 11.2337 13.4211 11.0774 13.5774C10.9211 13.7337 10.8333 13.9457 10.8333 14.1667C10.8333 14.3877 10.9211 14.5996 11.0774 14.7559C11.2337 14.9122 11.4457 15 11.6667 15H13.3333V16.6667C13.3333 16.8877 13.4211 17.0996 13.5774 17.2559C13.7337 17.4122 13.9457 17.5 14.1667 17.5C14.3877 17.5 14.5996 17.4122 14.7559 17.2559C14.9122 17.0996 15 16.8877 15 16.6667V15H16.6667C16.8877 15 17.0996 14.9122 17.2559 14.7559C17.4122 14.5996 17.5 14.3877 17.5 14.1667C17.5 13.9457 17.4122 13.7337 17.2559 13.5774C17.0996 13.4211 16.8877 13.3333 16.6667 13.3333ZM8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5ZM7.5 7.5H4.16667V4.16667H7.5V7.5Z"
                    fill={location.pathname === "/" ? "#F99F21" : "white"}
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Dashboard</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        {/* start master dropdown */}
        <ListItem disablePadding>
          <ListItemButton onClick={() => setMasterOpen(!masterOpen)}>
            <ListItemIcon>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6667 6.81663V2.49996C16.6667 2.27895 16.5789 2.06698 16.4226 1.9107C16.2663 1.75442 16.0544 1.66663 15.8333 1.66663C15.6123 1.66663 15.4004 1.75442 15.2441 1.9107C15.0878 2.06698 15 2.27895 15 2.49996V6.81663C14.5174 6.9918 14.1004 7.31132 13.8057 7.73176C13.511 8.15221 13.3529 8.65319 13.3529 9.16663C13.3529 9.68006 13.511 10.181 13.8057 10.6015C14.1004 11.0219 14.5174 11.3415 15 11.5166V17.5C15 17.721 15.0878 17.9329 15.2441 18.0892C15.4004 18.2455 15.6123 18.3333 15.8333 18.3333C16.0544 18.3333 16.2663 18.2455 16.4226 18.0892C16.5789 17.9329 16.6667 17.721 16.6667 17.5V11.5166C17.1493 11.3415 17.5663 11.0219 17.861 10.6015C18.1557 10.181 18.3137 9.68006 18.3137 9.16663C18.3137 8.65319 18.1557 8.15221 17.861 7.73176C17.5663 7.31132 17.1493 6.9918 16.6667 6.81663ZM15.8333 9.99996C15.6685 9.99996 15.5074 9.95109 15.3704 9.85952C15.2333 9.76795 15.1265 9.6378 15.0634 9.48553C15.0004 9.33326 14.9839 9.1657 15.016 9.00405C15.0482 8.8424 15.1275 8.69391 15.2441 8.57737C15.3606 8.46083 15.5091 8.38146 15.6708 8.3493C15.8324 8.31715 16 8.33365 16.1522 8.39673C16.3045 8.4598 16.4347 8.56661 16.5262 8.70365C16.6178 8.84069 16.6667 9.00181 16.6667 9.16663C16.6667 9.38764 16.5789 9.5996 16.4226 9.75588C16.2663 9.91216 16.0544 9.99996 15.8333 9.99996ZM10.8333 11.8166V2.49996C10.8333 2.27895 10.7455 2.06698 10.5893 1.9107C10.433 1.75442 10.221 1.66663 10 1.66663C9.779 1.66663 9.56703 1.75442 9.41075 1.9107C9.25447 2.06698 9.16668 2.27895 9.16668 2.49996V11.8166C8.68405 11.9918 8.26706 12.3113 7.97238 12.7318C7.6777 13.1522 7.51961 13.6532 7.51961 14.1666C7.51961 14.6801 7.6777 15.181 7.97238 15.6015C8.26706 16.0219 8.68405 16.3415 9.16668 16.5166V17.5C9.16668 17.721 9.25447 17.9329 9.41075 18.0892C9.56703 18.2455 9.779 18.3333 10 18.3333C10.221 18.3333 10.433 18.2455 10.5893 18.0892C10.7455 17.9329 10.8333 17.721 10.8333 17.5V16.5166C11.316 16.3415 11.733 16.0219 12.0276 15.6015C12.3223 15.181 12.4804 14.6801 12.4804 14.1666C12.4804 13.6532 12.3223 13.1522 12.0276 12.7318C11.733 12.3113 11.316 11.9918 10.8333 11.8166ZM10 15C9.83519 15 9.67408 14.9511 9.53703 14.8595C9.39999 14.768 9.29318 14.6378 9.23011 14.4855C9.16704 14.3333 9.15053 14.1657 9.18269 14.004C9.21484 13.8424 9.29421 13.6939 9.41075 13.5774C9.5273 13.4608 9.67578 13.3815 9.83743 13.3493C9.99909 13.3172 10.1666 13.3337 10.3189 13.3967C10.4712 13.4598 10.6013 13.5666 10.6929 13.7037C10.7845 13.8407 10.8333 14.0018 10.8333 14.1666C10.8333 14.3876 10.7455 14.5996 10.5893 14.7559C10.433 14.9122 10.221 15 10 15ZM5.00001 5.14996V2.49996C5.00001 2.27895 4.91221 2.06698 4.75593 1.9107C4.59965 1.75442 4.38769 1.66663 4.16668 1.66663C3.94566 1.66663 3.7337 1.75442 3.57742 1.9107C3.42114 2.06698 3.33334 2.27895 3.33334 2.49996V5.14996C2.85072 5.32513 2.43373 5.64465 2.13904 6.0651C1.84436 6.48554 1.68628 6.98653 1.68628 7.49996C1.68628 8.01339 1.84436 8.51437 2.13904 8.93482C2.43373 9.35527 2.85072 9.67479 3.33334 9.84996V17.5C3.33334 17.721 3.42114 17.9329 3.57742 18.0892C3.7337 18.2455 3.94566 18.3333 4.16668 18.3333C4.38769 18.3333 4.59965 18.2455 4.75593 18.0892C4.91221 17.9329 5.00001 17.721 5.00001 17.5V9.84996C5.48264 9.67479 5.89963 9.35527 6.19431 8.93482C6.48899 8.51437 6.64707 8.01339 6.64707 7.49996C6.64707 6.98653 6.48899 6.48554 6.19431 6.0651C5.89963 5.64465 5.48264 5.32513 5.00001 5.14996ZM4.16668 8.33329C4.00186 8.33329 3.84074 8.28442 3.7037 8.19285C3.56666 8.10128 3.45985 7.97113 3.39678 7.81886C3.3337 7.66659 3.3172 7.49903 3.34936 7.33738C3.38151 7.17573 3.46088 7.02725 3.57742 6.9107C3.69396 6.79416 3.84245 6.71479 4.0041 6.68264C4.16575 6.65048 4.33331 6.66699 4.48558 6.73006C4.63785 6.79313 4.768 6.89994 4.85957 7.03698C4.95114 7.17402 5.00001 7.33514 5.00001 7.49996C5.00001 7.72097 4.91221 7.93293 4.75593 8.08921C4.59965 8.24549 4.38769 8.33329 4.16668 8.33329Z"
                  fill={
                    location.pathname === "/seller_list" ||
                    location.pathname === "/area_list" ||
                    location.pathname === "/all_categories" ||
                    location.pathname === "/testimonial" ||
                    location.pathname === "/warranty_return_policy" ||
                    location.pathname === "/care-instruction" ||
                    location.pathname === "/subscribe-mail" ||
                    location.pathname === "/enquiry-mail" ||
                    location.pathname === "/img-setting"
                      ? "#F99F21"
                      : "white"
                  }
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">Master</ListItemText>
            <span className="pe-3">
              {" "}
              {masterOpen ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {masterOpen && (
          <List>
            {/* <Link to="/seller_list" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/seller_list"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item11")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg">
                   
                  </ListItemIcon>
                  <ListItemText className="custom-font">Seller</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link> */}
            <Link to="/area_list" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/area_list" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item11")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">Area</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            {/* <Link to="/blogs" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/blogs" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item110")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg">
                   
                  </ListItemIcon>
                  <ListItemText className="custom-font">Blogs</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link> */}
            <Link to="/all_categories" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/all_categories"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item2")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Categories
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            {/* <Link to="/our_achievements" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/our_achievements"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item70")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg">
                  </ListItemIcon>
                  <ListItemText className="custom-font">Our Achievements</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link> */}
            <Link to="/testimonial" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/testimonial"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item111")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg"></ListItemIcon>
                  <ListItemText className="custom-font">
                    Testimonial
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/warranty_return_policy" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/warranty_return_policy"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item55")}
              >
                <ListItemButton>
                  <ListItemIcon>
                    {/* <img
                  src={require("../assets/images/tables-icon/warranty.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                  </ListItemIcon>
                  <ListItemText className="custom-font">
                    {" "}
                    Warranty & Return Policy
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/care-instruction" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/care-instruction"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item55")}
              >
                <ListItemButton>
                  <ListItemIcon>
                    {/* <img
                  src={require("../assets/images/tables-icon/warranty.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                  </ListItemIcon>
                  <ListItemText className="custom-font">
                    {" "}
                    Care & Instruction
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/subscribe-mail" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/subscribe-mail"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item55")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Subscribe Mail
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/enquiry-mail" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/enquiry-mail"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item55_00")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Enquiry Mail
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/img-setting" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/img-setting"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item55")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Images Setting
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/welcome_bonus" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/welcome_bonus"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item20")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Welcome Bonus
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/promotion_message" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/promotion_message"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item270")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Promotion Message
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )}
        {/* end master dropdown */}

        <Link to="/orders" className="link_tag">
          <ListItem
            className={
              location.pathname === "/orders" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item9_00")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6667 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5ZM9.16667 15.8333H4.16667V10.8333H9.16667V15.8333ZM9.16667 9.16667H4.16667V4.16667H9.16667V9.16667ZM15.8333 15.8333H10.8333V10.8333H15.8333V15.8333ZM15.8333 9.16667H10.8333V4.16667H15.8333V9.16667Z"
                    fill={location.pathname === "/orders" ? "#F99F21" : "white"}
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Orders</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>

        <Link to="/return_replace" className="link_tag">
          <ListItem
            className={
              location.pathname === "/return_replace"
                ? "active"
                : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item9_000")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.53333 1.66663C7.39699 1.67272 5.34457 2.49905 3.8 3.97496V2.49996C3.8 2.27895 3.7122 2.06698 3.55592 1.9107C3.39964 1.75442 3.18768 1.66663 2.96666 1.66663C2.74565 1.66663 2.53369 1.75442 2.37741 1.9107C2.22113 2.06698 2.13333 2.27895 2.13333 2.49996V6.24996C2.13333 6.47097 2.22113 6.68293 2.37741 6.83921C2.53369 6.99549 2.74565 7.08329 2.96666 7.08329H6.71667C6.93768 7.08329 7.14964 6.99549 7.30592 6.83921C7.4622 6.68293 7.55 6.47097 7.55 6.24996C7.55 6.02895 7.4622 5.81698 7.30592 5.6607C7.14964 5.50442 6.93768 5.41663 6.71667 5.41663H4.71666C5.47642 4.61413 6.42375 4.01309 7.47344 3.66757C8.52312 3.32205 9.64224 3.24289 10.7301 3.43721C11.818 3.63153 12.8405 4.09323 13.7056 4.78078C14.5708 5.46834 15.2515 6.36017 15.6864 7.37607C16.1214 8.39196 16.297 9.50005 16.1974 10.6006C16.0978 11.7012 15.7262 12.7598 15.116 13.6812C14.5058 14.6025 13.6762 15.3577 12.7017 15.8788C11.7272 16.4 10.6384 16.6707 9.53333 16.6666C9.31232 16.6666 9.10036 16.7544 8.94408 16.9107C8.7878 17.067 8.7 17.2789 8.7 17.5C8.7 17.721 8.7878 17.9329 8.94408 18.0892C9.10036 18.2455 9.31232 18.3333 9.53333 18.3333C11.7435 18.3333 13.8631 17.4553 15.4259 15.8925C16.9887 14.3297 17.8667 12.2101 17.8667 9.99996C17.8667 7.78982 16.9887 5.67021 15.4259 4.1074C13.8631 2.5446 11.7435 1.66663 9.53333 1.66663ZM9.53333 6.66663C9.31232 6.66663 9.10036 6.75442 8.94408 6.9107C8.7878 7.06698 8.7 7.27895 8.7 7.49996V9.99996C8.7 10.221 8.7878 10.4329 8.94408 10.5892C9.10036 10.7455 9.31232 10.8333 9.53333 10.8333H11.2C11.421 10.8333 11.633 10.7455 11.7893 10.5892C11.9455 10.4329 12.0333 10.221 12.0333 9.99996C12.0333 9.77894 11.9455 9.56698 11.7893 9.4107C11.633 9.25442 11.421 9.16663 11.2 9.16663H10.3667V7.49996C10.3667 7.27895 10.2789 7.06698 10.1226 6.9107C9.96631 6.75442 9.75434 6.66663 9.53333 6.66663Z"
                    fill={
                      location.pathname === "/return_replace"
                        ? "#F99F21"
                        : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">
                Return & Replace
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>

        <Link to="/app_user" className="link_tag">
          <ListItem
            className={
              location.pathname === "/app_user" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item9")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.3417 10.2333C12.8691 9.66683 13.1663 8.92394 13.175 8.14996C13.175 7.31453 12.8431 6.51331 12.2524 5.92257C11.6616 5.33183 10.8604 4.99996 10.025 4.99996C9.18956 4.99996 8.38834 5.33183 7.7976 5.92257C7.20686 6.51331 6.87499 7.31453 6.87499 8.14996C6.88369 8.92394 7.18084 9.66683 7.70832 10.2333C6.97387 10.599 6.34184 11.1416 5.86909 11.8122C5.39633 12.4827 5.09768 13.2603 4.99999 14.075C4.97568 14.296 5.04016 14.5176 5.17925 14.6911C5.31834 14.8645 5.52064 14.9756 5.74166 15C5.96267 15.0243 6.18429 14.9598 6.35776 14.8207C6.53123 14.6816 6.64234 14.4793 6.66666 14.2583C6.7661 13.4509 7.15736 12.7078 7.76673 12.1688C8.3761 11.6299 9.1615 11.3324 9.97499 11.3324C10.7885 11.3324 11.5739 11.6299 12.1833 12.1688C12.7926 12.7078 13.1839 13.4509 13.2833 14.2583C13.3065 14.472 13.4113 14.6684 13.5759 14.8066C13.7406 14.9448 13.9522 15.0141 14.1667 15H14.2583C14.4768 14.9748 14.6764 14.8644 14.8138 14.6927C14.9512 14.521 15.0151 14.3019 14.9917 14.0833C14.9012 13.2729 14.612 12.4975 14.1497 11.8258C13.6874 11.1542 13.0663 10.6071 12.3417 10.2333ZM9.99999 9.63329C9.70661 9.63329 9.41983 9.5463 9.17589 9.38331C8.93196 9.22031 8.74184 8.98865 8.62957 8.71761C8.5173 8.44656 8.48792 8.14831 8.54516 7.86058C8.60239 7.57284 8.74367 7.30853 8.95111 7.10108C9.15856 6.89364 9.42287 6.75236 9.71061 6.69513C9.99834 6.63789 10.2966 6.66727 10.5676 6.77954C10.8387 6.89181 11.0703 7.08193 11.2333 7.32586C11.3963 7.5698 11.4833 7.85658 11.4833 8.14996C11.4833 8.54336 11.327 8.92066 11.0489 9.19883C10.7707 9.47701 10.3934 9.63329 9.99999 9.63329ZM15.8333 1.66663H4.16666C3.50362 1.66663 2.86773 1.93002 2.39889 2.39886C1.93005 2.8677 1.66666 3.50358 1.66666 4.16663V15.8333C1.66666 16.4963 1.93005 17.1322 2.39889 17.6011C2.86773 18.0699 3.50362 18.3333 4.16666 18.3333H15.8333C16.4964 18.3333 17.1322 18.0699 17.6011 17.6011C18.0699 17.1322 18.3333 16.4963 18.3333 15.8333V4.16663C18.3333 3.50358 18.0699 2.8677 17.6011 2.39886C17.1322 1.93002 16.4964 1.66663 15.8333 1.66663ZM16.6667 15.8333C16.6667 16.0543 16.5789 16.2663 16.4226 16.4225C16.2663 16.5788 16.0543 16.6666 15.8333 16.6666H4.16666C3.94564 16.6666 3.73368 16.5788 3.5774 16.4225C3.42112 16.2663 3.33332 16.0543 3.33332 15.8333V4.16663C3.33332 3.94561 3.42112 3.73365 3.5774 3.57737C3.73368 3.42109 3.94564 3.33329 4.16666 3.33329H15.8333C16.0543 3.33329 16.2663 3.42109 16.4226 3.57737C16.5789 3.73365 16.6667 3.94561 16.6667 4.16663V15.8333Z"
                    fill={
                      location.pathname === "/app_user" ? "#F99F21" : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Customers</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>

        {/* <Link to="/all_categories" className="link_tag">
          <ListItem
            className={
              location.pathname === "/all_services" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item2")}
          >
            <ListItemButton>
              <ListItemIcon>
                <img
                  src={require("../assets/images/tables-icon/categorises.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Categories</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}

        {/* <ListItem disablePadding>
          <ListItemButton onClick={() => setCatOpen(!catOpen)}>
            <ListItemIcon>
              <img
                src={require("../assets/images/tables-icon/categorises.png")}
                className="img-fluid"
                alt=""
              />
            </ListItemIcon>
            <ListItemText className="custom-font">Categories</ListItemText>
            <span className="pe-3">
              {" "}
              {catOpen ? (
                <KeyboardArrowRightIcon className="fs-6" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {catOpen && (
          <List>
            <Link to="/all_categories" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/all_categories"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item2")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Product Category</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/all_services" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/all_services"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item3")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Service Category</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/catalogue" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/catalogue" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item4")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Catalogue Category</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )} */}
        {/* <Link to="/area_list" className="link_tag">
          <ListItem
            className={
              location.pathname === "/area_list" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item11")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/area.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Area</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}
        {/* <Link to="/blogs" className="link_tag">
          <ListItem
            className={
              location.pathname === "/blogs" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item110")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/blog.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Blogs</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}

        <Link to="/products" className="link_tag">
          <ListItem
            className={
              location.pathname === "/products" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item2")}
          >
            <ListItemButton>
              <ListItemIcon>
                {/* <img
                  src={require("../assets/images/tables-icon/products.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8333 5.83329H13.3333V4.99996C13.3333 4.1159 12.9822 3.26806 12.357 2.64294C11.7319 2.01782 10.8841 1.66663 10 1.66663C9.11595 1.66663 8.26811 2.01782 7.64299 2.64294C7.01787 3.26806 6.66668 4.1159 6.66668 4.99996V5.83329H4.16668C3.94566 5.83329 3.7337 5.92109 3.57742 6.07737C3.42114 6.23365 3.33334 6.44561 3.33334 6.66663V15.8333C3.33334 16.4963 3.59674 17.1322 4.06558 17.6011C4.53442 18.0699 5.1703 18.3333 5.83334 18.3333H14.1667C14.8297 18.3333 15.4656 18.0699 15.9344 17.6011C16.4033 17.1322 16.6667 16.4963 16.6667 15.8333V6.66663C16.6667 6.44561 16.5789 6.23365 16.4226 6.07737C16.2663 5.92109 16.0544 5.83329 15.8333 5.83329ZM8.33334 4.99996C8.33334 4.55793 8.50894 4.13401 8.8215 3.82145C9.13406 3.50889 9.55798 3.33329 10 3.33329C10.442 3.33329 10.866 3.50889 11.1785 3.82145C11.4911 4.13401 11.6667 4.55793 11.6667 4.99996V5.83329H8.33334V4.99996ZM15 15.8333C15 16.0543 14.9122 16.2663 14.7559 16.4225C14.5997 16.5788 14.3877 16.6666 14.1667 16.6666H5.83334C5.61233 16.6666 5.40037 16.5788 5.24409 16.4225C5.08781 16.2663 5.00001 16.0543 5.00001 15.8333V7.49996H6.66668V8.33329C6.66668 8.55431 6.75447 8.76627 6.91075 8.92255C7.06703 9.07883 7.279 9.16663 7.50001 9.16663C7.72102 9.16663 7.93299 9.07883 8.08927 8.92255C8.24555 8.76627 8.33334 8.55431 8.33334 8.33329V7.49996H11.6667V8.33329C11.6667 8.55431 11.7545 8.76627 11.9108 8.92255C12.067 9.07883 12.279 9.16663 12.5 9.16663C12.721 9.16663 12.933 9.07883 13.0893 8.92255C13.2455 8.76627 13.3333 8.55431 13.3333 8.33329V7.49996H15V15.8333Z"
                    fill={
                      location.pathname === "/products" ? "#F99F21" : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Products</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>

        {/* <ListItem disablePadding>
          <ListItemButton onClick={() => setProductOpen(!productOpen)}>
            <ListItemIcon>
              <img
                src={require("../assets/images/tables-icon/products.png")}
                className="img-fluid"
                alt=""
              />
            </ListItemIcon>
            <ListItemText className="custom-font">Products</ListItemText>
            <span className="pe-3">
              {" "}
              {productOpen ? (
                <KeyboardArrowRightIcon className="fs-6" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {productOpen && (
          <List>
            <Link to="/products" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/products" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item2")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Manage Product</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/services" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/services" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item3")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Manage Service</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/manage_catalogue" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/manage_catalogue"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item4")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Manage Catalogue</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/add_coupon" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/add_coupon"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item40")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Coupon Banner</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )} */}

        {/* <Link to="/our_achievements" className="link_tag">
          <ListItem
            className={
              location.pathname === "/our_achievements"
                ? "active"
                : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item70")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/accivement.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Our Achievements</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}

        {/* <Link to="/product_order" className="link_tag">
          <ListItem
            className={
              location.pathname === "/product_order" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item13")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/purchase_order.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Purchase Orders</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}
        {/* <ListItem disablePadding>
          <ListItemButton
            onClick={() => setDeliveryScheduleOpen(!DeliveryScheduleOpen)}
          >
            <ListItemIcon className="icon_bg">
              <img
                src={require("../assets/images/tables-icon/delivery_schedule.png")}
                className="img-fluid"
                alt=""
              />
            </ListItemIcon>
            <ListItemText className="custom-font">Schedule</ListItemText>
            <span className="pe-3">
              {" "}
              {DeliveryScheduleOpen ? (
                <KeyboardArrowRightIcon className="fs-6" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {DeliveryScheduleOpen && (
          <List>
            <Link to="/time_slot" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/time_slot" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item14")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Time Slot </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/closing_hours" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/closing_hours"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item34")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Closing Hour </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )} */}
        {/* <Link to="/stock_update" className="link_tag">
          <ListItem
            className={
              location.pathname === "/stock_update" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item15")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/stock_update.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Stock Management</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <ListItem disablePadding>
          <ListItemButton onClick={() => setDeliveryBoyOpen(!DeliveryBoyOpen)}>
            <ListItemIcon className="icon_bg">
              <img
                src={require("../assets/images/tables-icon/delivery_boy.png")}
                className="img-fluid"
                alt=""
              />
            </ListItemIcon>
            <ListItemText className="custom-font">Manage Delivery </ListItemText>
            <span className="pe-3">
              {" "}
              {DeliveryBoyOpen ? (
                <KeyboardArrowRightIcon className="fs-6" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {DeliveryBoyOpen && (
          <List>
            <Link to="/delivery_boy_list" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/delivery_boy_list"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item16")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">List Delivery Boy </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )} */}

        <ListItem disablePadding>
          <ListItemButton onClick={() => setPagesOpen(!PagesOpen)}>
            <ListItemIcon>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.7667 7.9583L16.1917 7.4333L16.9333 5.94996C17.0085 5.7947 17.0337 5.61993 17.0053 5.44977C16.9769 5.27961 16.8965 5.12245 16.775 4.99996L15 3.22496C14.8769 3.1017 14.7182 3.02013 14.5463 2.99173C14.3744 2.96333 14.1979 2.98953 14.0417 3.06663L12.5583 3.8083L12.0333 2.2333C11.9779 2.06912 11.8726 1.92632 11.7322 1.82475C11.5918 1.72319 11.4233 1.66792 11.25 1.66663H8.74999C8.57529 1.66618 8.40486 1.72064 8.2628 1.82233C8.12074 1.92402 8.01423 2.06778 7.95833 2.2333L7.43333 3.8083L5.94999 3.06663C5.79473 2.99145 5.61996 2.9663 5.4498 2.99466C5.27964 3.02302 5.12248 3.10349 4.99999 3.22496L3.22499 4.99996C3.10173 5.1231 3.02016 5.28177 2.99176 5.45368C2.96336 5.62558 2.98956 5.80205 3.06666 5.9583L3.80833 7.44163L2.23333 7.96663C2.06915 8.02208 1.92635 8.12732 1.82478 8.26772C1.72322 8.40812 1.66795 8.57668 1.66666 8.74996V11.25C1.66621 11.4247 1.72068 11.5951 1.82236 11.7372C1.92405 11.8792 2.06781 11.9857 2.23333 12.0416L3.80833 12.5666L3.06666 14.05C2.99148 14.2052 2.96633 14.38 2.99469 14.5502C3.02305 14.7203 3.10352 14.8775 3.22499 15L4.99999 16.775C5.12313 16.8982 5.28181 16.9798 5.45371 17.0082C5.62561 17.0366 5.80208 17.0104 5.95833 16.9333L7.44166 16.1916L7.96666 17.7666C8.02256 17.9321 8.12907 18.0759 8.27114 18.1776C8.4132 18.2793 8.58362 18.3337 8.75833 18.3333H11.2583C11.433 18.3337 11.6035 18.2793 11.7455 18.1776C11.8876 18.0759 11.9941 17.9321 12.05 17.7666L12.575 16.1916L14.0583 16.9333C14.2126 17.0066 14.3857 17.0307 14.5541 17.0024C14.7225 16.9741 14.8782 16.8947 15 16.775L16.775 15C16.8983 14.8768 16.9798 14.7182 17.0082 14.5463C17.0366 14.3743 17.0104 14.1979 16.9333 14.0416L16.1917 12.5583L17.7667 12.0333C17.9308 11.9778 18.0736 11.8726 18.1752 11.7322C18.2768 11.5918 18.332 11.4232 18.3333 11.25V8.74996C18.3338 8.57526 18.2793 8.40483 18.1776 8.26277C18.0759 8.12071 17.9322 8.0142 17.7667 7.9583ZM16.6667 10.65L15.6667 10.9833C15.4367 11.0579 15.2257 11.1816 15.0484 11.3459C14.871 11.5102 14.7315 11.711 14.6395 11.9346C14.5476 12.1582 14.5054 12.3991 14.5158 12.6406C14.5262 12.8821 14.5891 13.1185 14.7 13.3333L15.175 14.2833L14.2583 15.2L13.3333 14.7C13.1196 14.5935 12.8855 14.5342 12.6469 14.526C12.4083 14.5179 12.1707 14.5611 11.9503 14.6528C11.7298 14.7445 11.5316 14.8824 11.3691 15.0573C11.2066 15.2322 11.0836 15.44 11.0083 15.6666L10.675 16.6666H9.34999L9.01666 15.6666C8.94207 15.4367 8.81835 15.2257 8.65408 15.0483C8.4898 14.871 8.28891 14.7315 8.06534 14.6395C7.84177 14.5475 7.60087 14.5053 7.35935 14.5158C7.11782 14.5262 6.88146 14.5891 6.66666 14.7L5.71666 15.175L4.79999 14.2583L5.29999 13.3333C5.4109 13.1185 5.47376 12.8821 5.4842 12.6406C5.49464 12.3991 5.45241 12.1582 5.36044 11.9346C5.26848 11.711 5.12897 11.5102 4.95161 11.3459C4.77425 11.1816 4.56328 11.0579 4.33333 10.9833L3.33333 10.65V9.34996L4.33333 9.01663C4.56328 8.94204 4.77425 8.81832 4.95161 8.65404C5.12897 8.48977 5.26848 8.28888 5.36044 8.06531C5.45241 7.84174 5.49464 7.60084 5.4842 7.35932C5.47376 7.11779 5.4109 6.88143 5.29999 6.66663L4.82499 5.74163L5.74166 4.82496L6.66666 5.29996C6.88146 5.41087 7.11782 5.47373 7.35935 5.48417C7.60087 5.49461 7.84177 5.45238 8.06534 5.36041C8.28891 5.26845 8.4898 5.12894 8.65408 4.95158C8.81835 4.77422 8.94207 4.56325 9.01666 4.3333L9.34999 3.3333H10.65L10.9833 4.3333C11.0579 4.56325 11.1816 4.77422 11.3459 4.95158C11.5102 5.12894 11.7111 5.26845 11.9346 5.36041C12.1582 5.45238 12.3991 5.49461 12.6406 5.48417C12.8822 5.47373 13.1185 5.41087 13.3333 5.29996L14.2833 4.82496L15.2 5.74163L14.7 6.66663C14.5935 6.88033 14.5342 7.11442 14.5261 7.35304C14.5179 7.59165 14.5612 7.82924 14.6528 8.0497C14.7445 8.27016 14.8824 8.46835 15.0574 8.63086C15.2323 8.79337 15.4401 8.9164 15.6667 8.99163L16.6667 9.32496V10.65ZM9.99999 6.66663C9.34072 6.66663 8.69626 6.86213 8.14809 7.2284C7.59993 7.59467 7.17269 8.11526 6.92039 8.72435C6.6681 9.33344 6.60209 10.0037 6.73071 10.6503C6.85933 11.2969 7.1768 11.8908 7.64297 12.357C8.10915 12.8232 8.70309 13.1406 9.34969 13.2692C9.99629 13.3979 10.6665 13.3319 11.2756 13.0796C11.8847 12.8273 12.4053 12.4 12.7716 11.8519C13.1378 11.3037 13.3333 10.6592 13.3333 9.99996C13.3333 9.11591 12.9821 8.26806 12.357 7.64294C11.7319 7.01782 10.884 6.66663 9.99999 6.66663ZM9.99999 11.6666C9.67036 11.6666 9.34812 11.5689 9.07404 11.3857C8.79996 11.2026 8.58634 10.9423 8.46019 10.6378C8.33405 10.3332 8.30104 9.99811 8.36535 9.67481C8.42966 9.35151 8.58839 9.05454 8.82148 8.82145C9.05457 8.58836 9.35154 8.42963 9.67484 8.36532C9.99814 8.30101 10.3333 8.33402 10.6378 8.46016C10.9423 8.58631 11.2026 8.79993 11.3858 9.07401C11.5689 9.34809 11.6667 9.67033 11.6667 9.99996C11.6667 10.442 11.4911 10.8659 11.1785 11.1785C10.8659 11.491 10.442 11.6666 9.99999 11.6666Z"
                  fill={
                    location.pathname === "/list" ||
                    location.pathname === "/banner_list" ||
                    location.pathname === "/about" ||
                    location.pathname === "/configuration"
                      ? "#F99F21"
                      : "white"
                  }
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">
              Portal & Setting
            </ListItemText>
            <span className="pe-3">
              {" "}
              {PagesOpen ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {PagesOpen && (
          <List>
            {/* <Link to="/configuration" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/configuration"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item107")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Configuration
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link> */}
            <Link to="/list" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/list" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item17")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Page List</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/banner_list" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/banner_list"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item17_7")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Website Banner
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/about" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/about" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item17")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">About Us</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )}
        {/* <Link to="/declared_reward" className="link_tag">
          <ListItem
            className={
              location.pathname === "/declared_reward"
                ? "active"
                : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item18")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/reward_value.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Reward & Bonus</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/refer" className="link_tag">
          <ListItem
            className={
              location.pathname === "/refer" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item19")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/referal_amount.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Referal Amount</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}
        {/* <Link to="/order_limit_setting" className="link_tag">
          <ListItem
            className={
              location.pathname === "/order_limit_setting"
                ? "active"
                : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item21")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/order_limit.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Order limit Setting</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/offer" className="link_tag">
          <ListItem
            className={
              location.pathname === "/offer" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item22")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/offers.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Offers</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/stock" className="link_tag">
          <ListItem
            className={
              location.pathname === "/stock" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item23")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/stock.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Stock</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/notification" className="link_tag">
          <ListItem
            className={
              location.pathname === "/notification" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item24")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/notification.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Notification</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}

        <ListItem disablePadding>
          <ListItemButton onClick={() => setSlideOpen(!slideOpen)}>
            <ListItemIcon>
              {/* <img
                src={require("../assets/images/tables-icon/slider.png")}
                className="img-fluid"
                alt=""
              /> */}
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 9.16667H14.8464C14.6766 8.67974 14.3595 8.2577 13.9391 7.95907C13.5186 7.66044 13.0157 7.5 12.5 7.5C11.9843 7.5 11.4814 7.66044 11.0609 7.95907C10.6405 8.2577 10.3234 8.67974 10.1535 9.16667H2.49999C2.27898 9.16667 2.06701 9.25447 1.91073 9.41075C1.75445 9.56703 1.66666 9.77899 1.66666 10C1.66666 10.221 1.75445 10.433 1.91073 10.5893C2.06701 10.7455 2.27898 10.8333 2.49999 10.8333H10.1536C10.3234 11.3203 10.6405 11.7423 11.0609 12.041C11.4814 12.3396 11.9843 12.5001 12.5 12.5001C13.0157 12.5001 13.5187 12.3396 13.9391 12.041C14.3595 11.7423 14.6766 11.3203 14.8464 10.8333H17.5C17.721 10.8333 17.933 10.7455 18.0892 10.5893C18.2455 10.433 18.3333 10.221 18.3333 10C18.3333 9.77899 18.2455 9.56703 18.0892 9.41075C17.933 9.25447 17.721 9.16667 17.5 9.16667ZM12.5 10.8333C12.3352 10.8333 12.1741 10.7845 12.037 10.6929C11.9 10.6013 11.7932 10.4712 11.7301 10.3189C11.667 10.1666 11.6505 9.99908 11.6827 9.83743C11.7148 9.67578 11.7942 9.52729 11.9107 9.41075C12.0273 9.29421 12.1758 9.21484 12.3374 9.18269C12.4991 9.15053 12.6666 9.16703 12.8189 9.23011C12.9712 9.29318 13.1013 9.39999 13.1929 9.53703C13.2844 9.67407 13.3333 9.83519 13.3333 10C13.333 10.2209 13.2451 10.4327 13.0889 10.5889C12.9327 10.7452 12.7209 10.8331 12.5 10.8333Z"
                  fill={
                    location.pathname === "/main_slider" ||
                    location.pathname === "/mobile_slider"
                      ? "#F99F21"
                      : "white"
                  }
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">Slider</ListItemText>
            <span className="pe-3">
              {" "}
              {slideOpen ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {slideOpen && (
          <List>
            <Link to="/main_slider" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/main_slider"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item25")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Main Slider
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/mobile_slider" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/mobile_slider"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item25")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Mobile Slider
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            {/* <Link to="/category_banner" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/category_banner"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item73")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Category Banner</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/home_popup_img" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/home_popup_img"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item40")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg">
                  </ListItemIcon>
                  <ListItemText className="custom-font">Home Pop Up Images</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link> */}
            {/* <Link to="/feature_brand_slider" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/feature_brand_slider"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item26")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Feature Brand Slider</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            
            <Link to="/promotion_section" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/promotion_section"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item28")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Promotion Section</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/login_offer_image" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/login_offer_image"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item29")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Before/After Login Offer Image</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link> */}
          </List>
        )}

        {/* faq */}

        <ListItem disablePadding>
          <ListItemButton onClick={() => setFaqOpen(!faqOpen)}>
            <ListItemIcon>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.50001 8.33329H8.33334C8.55436 8.33329 8.76632 8.24549 8.9226 8.08921C9.07888 7.93293 9.16668 7.72097 9.16668 7.49996C9.16668 7.27895 9.07888 7.06698 8.9226 6.9107C8.76632 6.75442 8.55436 6.66663 8.33334 6.66663H7.50001C7.279 6.66663 7.06703 6.75442 6.91075 6.9107C6.75447 7.06698 6.66668 7.27895 6.66668 7.49996C6.66668 7.72097 6.75447 7.93293 6.91075 8.08921C7.06703 8.24549 7.279 8.33329 7.50001 8.33329ZM7.50001 9.99996C7.279 9.99996 7.06703 10.0878 6.91075 10.244C6.75447 10.4003 6.66668 10.6123 6.66668 10.8333C6.66668 11.0543 6.75447 11.2663 6.91075 11.4225C7.06703 11.5788 7.279 11.6666 7.50001 11.6666H12.5C12.721 11.6666 12.933 11.5788 13.0893 11.4225C13.2455 11.2663 13.3333 11.0543 13.3333 10.8333C13.3333 10.6123 13.2455 10.4003 13.0893 10.244C12.933 10.0878 12.721 9.99996 12.5 9.99996H7.50001ZM16.6667 7.44996C16.658 7.3734 16.6412 7.29798 16.6167 7.22496V7.14996C16.5766 7.06428 16.5232 6.98551 16.4583 6.91663L11.4583 1.91663C11.3895 1.85181 11.3107 1.79836 11.225 1.75829C11.2001 1.75476 11.1749 1.75476 11.15 1.75829C11.0654 1.70974 10.9719 1.67858 10.875 1.66663H5.83334C5.1703 1.66663 4.53442 1.93002 4.06558 2.39886C3.59674 2.8677 3.33334 3.50358 3.33334 4.16663V15.8333C3.33334 16.4963 3.59674 17.1322 4.06558 17.6011C4.53442 18.0699 5.1703 18.3333 5.83334 18.3333H14.1667C14.8297 18.3333 15.4656 18.0699 15.9344 17.6011C16.4033 17.1322 16.6667 16.4963 16.6667 15.8333V7.49996C16.6667 7.49996 16.6667 7.49996 16.6667 7.44996ZM11.6667 4.50829L13.825 6.66663H12.5C12.279 6.66663 12.067 6.57883 11.9108 6.42255C11.7545 6.26627 11.6667 6.05431 11.6667 5.83329V4.50829ZM15 15.8333C15 16.0543 14.9122 16.2663 14.7559 16.4225C14.5997 16.5788 14.3877 16.6666 14.1667 16.6666H5.83334C5.61233 16.6666 5.40037 16.5788 5.24409 16.4225C5.08781 16.2663 5.00001 16.0543 5.00001 15.8333V4.16663C5.00001 3.94561 5.08781 3.73365 5.24409 3.57737C5.40037 3.42109 5.61233 3.33329 5.83334 3.33329H10V5.83329C10 6.49633 10.2634 7.13222 10.7322 7.60106C11.2011 8.0699 11.837 8.33329 12.5 8.33329H15V15.8333ZM12.5 13.3333H7.50001C7.279 13.3333 7.06703 13.4211 6.91075 13.5774C6.75447 13.7336 6.66668 13.9456 6.66668 14.1666C6.66668 14.3876 6.75447 14.5996 6.91075 14.7559C7.06703 14.9122 7.279 15 7.50001 15H12.5C12.721 15 12.933 14.9122 13.0893 14.7559C13.2455 14.5996 13.3333 14.3876 13.3333 14.1666C13.3333 13.9456 13.2455 13.7336 13.0893 13.5774C12.933 13.4211 12.721 13.3333 12.5 13.3333Z"
                  fill={
                    location.pathname === "/faq" ||
                    location.pathname === "/faq_category"
                      ? "#F99F21"
                      : "white"
                  }
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">Faq</ListItemText>
            <span className="pe-3">
              {" "}
              {faqOpen ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem>
        {faqOpen && (
          <List>
            <Link to="/faq_category" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/faq_category"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item25_0")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">
                    Faq Category
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/faq" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/faq" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item25")}
              >
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText className="custom-font">Faq List</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )}

        {/* start portfolio dropdown */}
        {/* <ListItem disablePadding>
          <ListItemButton onClick={() => setPortfolioOpen(!portfolioOpen)}>
            <ListItemIcon>
              <svg
                width={21}
                height={21}
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.25 11.625H1.5C1.20163 11.625 0.915483 11.7435 0.704505 11.9545C0.493526 12.1655 0.375 12.4516 0.375 12.75V19.5C0.375 19.7984 0.493526 20.0845 0.704505 20.2955C0.915483 20.5065 1.20163 20.625 1.5 20.625H8.25C8.54837 20.625 8.83452 20.5065 9.0455 20.2955C9.25647 20.0845 9.375 19.7984 9.375 19.5V12.75C9.375 12.4516 9.25647 12.1655 9.0455 11.9545C8.83452 11.7435 8.54837 11.625 8.25 11.625ZM7.125 18.375H2.625V13.875H7.125V18.375ZM19.5 0.375H12.75C12.4516 0.375 12.1655 0.493526 11.9545 0.704505C11.7435 0.915483 11.625 1.20163 11.625 1.5V8.25C11.625 8.54837 11.7435 8.83452 11.9545 9.0455C12.1655 9.25647 12.4516 9.375 12.75 9.375H19.5C19.7984 9.375 20.0845 9.25647 20.2955 9.0455C20.5065 8.83452 20.625 8.54837 20.625 8.25V1.5C20.625 1.20163 20.5065 0.915483 20.2955 0.704505C20.0845 0.493526 19.7984 0.375 19.5 0.375ZM18.375 7.125H13.875V2.625H18.375V7.125ZM19.5 15H17.25V12.75C17.25 12.4516 17.1315 12.1655 16.9205 11.9545C16.7095 11.7435 16.4234 11.625 16.125 11.625C15.8266 11.625 15.5405 11.7435 15.3295 11.9545C15.1185 12.1655 15 12.4516 15 12.75V15H12.75C12.4516 15 12.1655 15.1185 11.9545 15.3295C11.7435 15.5405 11.625 15.8266 11.625 16.125C11.625 16.4234 11.7435 16.7095 11.9545 16.9205C12.1655 17.1315 12.4516 17.25 12.75 17.25H15V19.5C15 19.7984 15.1185 20.0845 15.3295 20.2955C15.5405 20.5065 15.8266 20.625 16.125 20.625C16.4234 20.625 16.7095 20.5065 16.9205 20.2955C17.1315 20.0845 17.25 19.7984 17.25 19.5V17.25H19.5C19.7984 17.25 20.0845 17.1315 20.2955 16.9205C20.5065 16.7095 20.625 16.4234 20.625 16.125C20.625 15.8266 20.5065 15.5405 20.2955 15.3295C20.0845 15.1185 19.7984 15 19.5 15ZM8.25 0.375H1.5C1.20163 0.375 0.915483 0.493526 0.704505 0.704505C0.493526 0.915483 0.375 1.20163 0.375 1.5V8.25C0.375 8.54837 0.493526 8.83452 0.704505 9.0455C0.915483 9.25647 1.20163 9.375 1.5 9.375H8.25C8.54837 9.375 8.83452 9.25647 9.0455 9.0455C9.25647 8.83452 9.375 8.54837 9.375 8.25V1.5C9.375 1.20163 9.25647 0.915483 9.0455 0.704505C8.83452 0.493526 8.54837 0.375 8.25 0.375ZM7.125 7.125H2.625V2.625H7.125V7.125Z"
                  fill="#FFFFFF"
                />
              </svg>
            </ListItemIcon>
            <ListItemText className="link_tag_sidebar ">Portfolio</ListItemText>
            <span className="pe-3">
              {" "}
              {portfolioOpen ? (
                <KeyboardArrowRightIcon className="fs-6 text-white" />
              ) : (
                <KeyboardArrowDownIcon className="fs-6 text-white" />
              )}
            </span>
          </ListItemButton>
        </ListItem> */}
        {portfolioOpen && (
          <List>
            <Link to="/portfolio_category" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/portfolio_category"
                    ? "active"
                    : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item11_0")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg">
                    {/* <img
                  src={require("../assets/images/tables-icon/testimonial.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                  </ListItemIcon>
                  <ListItemText className="custom-font">Category</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
            <Link to="/portfolio" className="link_tag">
              <ListItem
                className={
                  location.pathname === "/portfolio" ? "active" : "bg_dashboard"
                }
                disablePadding
                onClick={() => handleClick("item11_00")}
              >
                <ListItemButton>
                  <ListItemIcon className="icon_bg">
                    {/* <img
                  src={require("../assets/images/tables-icon/testimonial.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                  </ListItemIcon>
                  <ListItemText className="custom-font">Portfolio</ListItemText>
                </ListItemButton>
              </ListItem>
            </Link>
          </List>
        )}
        {/* end portfolio dropdown */}

        <Link to="/coupons" className="link_tag">
          <ListItem
            className={
              location.pathname === "/coupons" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item30")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                {/* <img
                  src={require("../assets/images/tables-icon/coupon.png")}
                  className="img-fluid"
                  alt=""
                /> */}
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.49999 8.33329C7.27898 8.33329 7.06701 8.42109 6.91073 8.57737C6.75445 8.73365 6.66666 8.94561 6.66666 9.16663V10.8333C6.66666 11.0543 6.75445 11.2663 6.91073 11.4225C7.06701 11.5788 7.27898 11.6666 7.49999 11.6666C7.721 11.6666 7.93296 11.5788 8.08925 11.4225C8.24553 11.2663 8.33332 11.0543 8.33332 10.8333V9.16663C8.33332 8.94561 8.24553 8.73365 8.08925 8.57737C7.93296 8.42109 7.721 8.33329 7.49999 8.33329ZM17.5 9.16663C17.721 9.16663 17.933 9.07883 18.0892 8.92255C18.2455 8.76627 18.3333 8.55431 18.3333 8.33329V4.99996C18.3333 4.77895 18.2455 4.56698 18.0892 4.4107C17.933 4.25442 17.721 4.16663 17.5 4.16663H2.49999C2.27898 4.16663 2.06701 4.25442 1.91073 4.4107C1.75445 4.56698 1.66666 4.77895 1.66666 4.99996V8.33329C1.66666 8.55431 1.75445 8.76627 1.91073 8.92255C2.06701 9.07883 2.27898 9.16663 2.49999 9.16663C2.721 9.16663 2.93297 9.25442 3.08925 9.4107C3.24553 9.56698 3.33332 9.77895 3.33332 9.99996C3.33332 10.221 3.24553 10.4329 3.08925 10.5892C2.93297 10.7455 2.721 10.8333 2.49999 10.8333C2.27898 10.8333 2.06701 10.9211 1.91073 11.0774C1.75445 11.2337 1.66666 11.4456 1.66666 11.6666V15C1.66666 15.221 1.75445 15.4329 1.91073 15.5892C2.06701 15.7455 2.27898 15.8333 2.49999 15.8333H17.5C17.721 15.8333 17.933 15.7455 18.0892 15.5892C18.2455 15.4329 18.3333 15.221 18.3333 15V11.6666C18.3333 11.4456 18.2455 11.2337 18.0892 11.0774C17.933 10.9211 17.721 10.8333 17.5 10.8333C17.279 10.8333 17.067 10.7455 16.9107 10.5892C16.7545 10.4329 16.6667 10.221 16.6667 9.99996C16.6667 9.77895 16.7545 9.56698 16.9107 9.4107C17.067 9.25442 17.279 9.16663 17.5 9.16663ZM16.6667 7.64996C16.184 7.82513 15.767 8.14465 15.4724 8.5651C15.1777 8.98554 15.0196 9.48653 15.0196 9.99996C15.0196 10.5134 15.1777 11.0144 15.4724 11.4348C15.767 11.8553 16.184 12.1748 16.6667 12.35V14.1666H8.33332C8.33332 13.9456 8.24553 13.7337 8.08925 13.5774C7.93296 13.4211 7.721 13.3333 7.49999 13.3333C7.27898 13.3333 7.06701 13.4211 6.91073 13.5774C6.75445 13.7337 6.66666 13.9456 6.66666 14.1666H3.33332V12.35C3.81595 12.1748 4.23294 11.8553 4.52762 11.4348C4.8223 11.0144 4.98039 10.5134 4.98039 9.99996C4.98039 9.48653 4.8223 8.98554 4.52762 8.5651C4.23294 8.14465 3.81595 7.82513 3.33332 7.64996V5.83329H6.66666C6.66666 6.05431 6.75445 6.26627 6.91073 6.42255C7.06701 6.57883 7.27898 6.66663 7.49999 6.66663C7.721 6.66663 7.93296 6.57883 8.08925 6.42255C8.24553 6.26627 8.33332 6.05431 8.33332 5.83329H16.6667V7.64996Z"
                    fill={
                      location.pathname === "/coupons" ? "#F99F21" : "white"
                    }
                  />
                </svg>
              </ListItemIcon>
              <ListItemText className="custom-font">Coupons</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        {/* <Link to="/testimonial" className="link_tag">
          <ListItem
            className={
              location.pathname === "/testimonial" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item111")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/testimonial.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Testimonial</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}
        {/* <Link to="/cashback" className="link_tag">
          <ListItem
            className={
              location.pathname === "/cashback" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item31")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/cashback.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Cashback</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}
        {/* <Link to="/deal_products" className="link_tag">
          <ListItem
            className={
              location.pathname === "/deal_products" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item32")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/deal_products.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Deal Products</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link>
        <Link to="/raise_ticket" className="link_tag">
          <ListItem
            className={
              location.pathname === "/raise_ticket" ? "active" : "bg_dashboard"
            }
            disablePadding
            onClick={() => handleClick("item33")}
          >
            <ListItemButton>
              <ListItemIcon className="icon_bg">
                <img
                  src={require("../assets/images/tables-icon/raises_ticket.png")}
                  className="img-fluid"
                  alt=""
                />
              </ListItemIcon>
              <ListItemText className="custom-font">Raise a Ticket</ListItemText>
            </ListItemButton>
          </ListItem>
        </Link> */}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      {!isLoginPage && (
        <>
          <CssBaseline />
          <AppBar
            position="fixed"
            sx={{
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              ml: { sm: `${drawerWidth}px` },
            }}
          >
            <Toolbar
              sx={{
                display: "flex",
                justifyContent: "space-between",
                height: "40px",
                backgroundColor: "#FFFFFF",
                hideClasses,
              }}
            >
              <div className="d-flex align-items-center">
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" noWrap component="div">
                  <div className="me-2 admin_title_header">
                    {/* <AiFillHome
                      color="white"
                      style={{ fontSize: "24px", marginTop: "-5px" }}
                    /> */}
                    {/* <Link to="/">
                      <svg
                        width={26}
                        height={18}
                        viewBox="0 0 26 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.25 2.75H1.75C1.41848 2.75 1.10054 2.6183 0.866116 2.38388C0.631695 2.14946 0.5 1.83152 0.5 1.5C0.5 1.16848 0.631695 0.850537 0.866116 0.616117C1.10054 0.381696 1.41848 0.25 1.75 0.25H24.25C24.5815 0.25 24.8995 0.381696 25.1339 0.616117C25.3683 0.850537 25.5 1.16848 25.5 1.5C25.5 1.83152 25.3683 2.14946 25.1339 2.38388C24.8995 2.6183 24.5815 2.75 24.25 2.75ZM1.75 15.25H19.25C19.5815 15.25 19.8995 15.3817 20.1339 15.6161C20.3683 15.8505 20.5 16.1685 20.5 16.5C20.5 16.8315 20.3683 17.1495 20.1339 17.3839C19.8995 17.6183 19.5815 17.75 19.25 17.75H1.75C1.41848 17.75 1.10054 17.6183 0.866116 17.3839C0.631695 17.1495 0.5 16.8315 0.5 16.5C0.5 16.1685 0.631695 15.8505 0.866116 15.6161C1.10054 15.3817 1.41848 15.25 1.75 15.25ZM1.75 5.25H19.25C19.5815 5.25 19.8995 5.3817 20.1339 5.61612C20.3683 5.85054 20.5 6.16848 20.5 6.5C20.5 6.83152 20.3683 7.14946 20.1339 7.38388C19.8995 7.6183 19.5815 7.75 19.25 7.75H1.75C1.41848 7.75 1.10054 7.6183 0.866116 7.38388C0.631695 7.14946 0.5 6.83152 0.5 6.5C0.5 6.16848 0.631695 5.85054 0.866116 5.61612C1.10054 5.3817 1.41848 5.25 1.75 5.25ZM1.75 10.25H24.25C24.5815 10.25 24.8995 10.3817 25.1339 10.6161C25.3683 10.8505 25.5 11.1685 25.5 11.5C25.5 11.8315 25.3683 12.1495 25.1339 12.3839C24.8995 12.6183 24.5815 12.75 24.25 12.75H1.75C1.41848 12.75 1.10054 12.6183 0.866116 12.3839C0.631695 12.1495 0.5 11.8315 0.5 11.5C0.5 11.1685 0.631695 10.8505 0.866116 10.6161C1.10054 10.3817 1.41848 10.25 1.75 10.25Z"
                          fill="#818181"
                        />
                      </svg>
                    </Link> */}
                    <div>
                      <h5 className="header_heading">welcome back,</h5>
                      <p className="time_header_para">
                        <span style={{ color: "rgb(47 47 145)" }}>{day}</span>,{" "}
                        {restDateTime}
                      </p>
                    </div>
                  </div>{" "}
                </Typography>
              </div>
              {/* <div style={{ display: "flex", alignItems: "center" }}>
                <div className="search_div_header">
                  <div>
                    <input
                      type="text"
                      className="form-control search_header_input"
                      placeholder="Search for Anything..."
                    />
                  </div>
                  <div className="search_icon_input">
                    <svg
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.2825 14.2175L12.5 11.4575C13.5801 10.1108 14.1031 8.40147 13.9616 6.68097C13.8201 4.96047 13.0247 3.35958 11.7391 2.20748C10.4535 1.05538 8.77534 0.43963 7.04968 0.48685C5.32402 0.53407 3.68203 1.24067 2.46135 2.46135C1.24066 3.68204 0.534062 5.32403 0.486842 7.04969C0.439622 8.77535 1.05537 10.4535 2.20747 11.7391C3.35958 13.0247 4.96047 13.8201 6.68096 13.9616C8.40146 14.1031 10.1108 13.5801 11.4575 12.5L14.2175 15.26C14.2872 15.3303 14.3702 15.3861 14.4616 15.4242C14.5529 15.4622 14.651 15.4818 14.75 15.4818C14.849 15.4818 14.947 15.4622 15.0384 15.4242C15.1298 15.3861 15.2128 15.3303 15.2825 15.26C15.4177 15.1201 15.4932 14.9333 15.4932 14.7387C15.4932 14.5442 15.4177 14.3573 15.2825 14.2175ZM7.24999 12.5C6.21164 12.5 5.1966 12.1921 4.33325 11.6152C3.46989 11.0383 2.79698 10.2184 2.39962 9.25909C2.00226 8.29977 1.89829 7.24417 2.10087 6.22577C2.30344 5.20737 2.80345 4.27191 3.53768 3.53769C4.2719 2.80346 5.20737 2.30345 6.22577 2.10087C7.24416 1.8983 8.29977 2.00227 9.25908 2.39963C10.2184 2.79699 11.0383 3.4699 11.6152 4.33325C12.1921 5.19661 12.5 6.21165 12.5 7.25C12.5 8.64238 11.9469 9.97774 10.9623 10.9623C9.97773 11.9469 8.64237 12.5 7.24999 12.5Z"
                        fill="#818181"
                      />
                    </svg>
                  </div>
                  <div className="search_filter_icon">
                    <svg
                      width={40}
                      height={40}
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width={40} height={40} rx={20} fill="rgb(47 47 145)" />
                      <path
                        d="M22.865 26L26.75 26C26.9489 26 27.1397 25.921 27.2803 25.7803C27.421 25.6397 27.5 25.4489 27.5 25.25C27.5 25.0511 27.421 24.8603 27.2803 24.7197C27.1397 24.579 26.9489 24.5 26.75 24.5L22.865 24.5C22.7073 24.0656 22.4198 23.6903 22.0414 23.4251C21.663 23.1599 21.2121 23.0176 20.75 23.0176C20.2879 23.0176 19.837 23.1599 19.4586 23.4251C19.0802 23.6903 18.7927 24.0656 18.635 24.5L13.25 24.5C13.0511 24.5 12.8603 24.579 12.7197 24.7197C12.579 24.8603 12.5 25.0511 12.5 25.25C12.5 25.4489 12.579 25.6397 12.7197 25.7803C12.8603 25.921 13.0511 26 13.25 26L18.635 26C18.7927 26.4344 19.0802 26.8097 19.4586 27.0749C19.837 27.3401 20.2879 27.4824 20.75 27.4824C21.2121 27.4824 21.663 27.3401 22.0414 27.0749C22.4198 26.8097 22.7073 26.4344 22.865 26ZM20 25.25C20 25.1017 20.044 24.9567 20.1264 24.8333C20.2088 24.71 20.3259 24.6139 20.463 24.5571C20.6 24.5003 20.7508 24.4855 20.8963 24.5144C21.0418 24.5433 21.1754 24.6148 21.2803 24.7197C21.3852 24.8246 21.4567 24.9582 21.4856 25.1037C21.5145 25.2492 21.4997 25.4 21.4429 25.537C21.3861 25.6741 21.29 25.7912 21.1667 25.8736C21.0433 25.956 20.8983 26 20.75 26C20.5511 26 20.3603 25.921 20.2197 25.7803C20.079 25.6397 20 25.4489 20 25.25ZM18.365 20.75L26.75 20.75C26.9489 20.75 27.1397 20.671 27.2803 20.5303C27.421 20.3897 27.5 20.1989 27.5 20C27.5 19.8011 27.421 19.6103 27.2803 19.4697C27.1397 19.329 26.9489 19.25 26.75 19.25L18.365 19.25C18.2073 18.8156 17.9198 18.4403 17.5414 18.1751C17.163 17.9099 16.7121 17.7676 16.25 17.7676C15.7879 17.7676 15.337 17.9099 14.9586 18.1751C14.5802 18.4403 14.2927 18.8156 14.135 19.25L13.25 19.25C13.0511 19.25 12.8603 19.329 12.7197 19.4697C12.579 19.6103 12.5 19.8011 12.5 20C12.5 20.1989 12.579 20.3897 12.7197 20.5303C12.8603 20.671 13.0511 20.75 13.25 20.75L14.135 20.75C14.2927 21.1844 14.5802 21.5597 14.9586 21.8249C15.337 22.0901 15.7879 22.2324 16.25 22.2324C16.7121 22.2324 17.163 22.0901 17.5414 21.8249C17.9198 21.5597 18.2073 21.1844 18.365 20.75ZM15.5 20C15.5 19.8517 15.544 19.7067 15.6264 19.5833C15.7088 19.46 15.8259 19.3639 15.963 19.3071C16.1 19.2503 16.2508 19.2355 16.3963 19.2644C16.5418 19.2933 16.6754 19.3648 16.7803 19.4697C16.8852 19.5746 16.9567 19.7082 16.9856 19.8537C17.0145 19.9992 16.9997 20.15 16.9429 20.287C16.8861 20.4241 16.79 20.5412 16.6667 20.6236C16.5433 20.706 16.3983 20.75 16.25 20.75C16.0511 20.75 15.8603 20.671 15.7197 20.5303C15.579 20.3897 15.5 20.1989 15.5 20ZM24.365 15.5L26.75 15.5C26.9489 15.5 27.1397 15.421 27.2803 15.2803C27.421 15.1397 27.5 14.9489 27.5 14.75C27.5 14.5511 27.421 14.3603 27.2803 14.2197C27.1397 14.079 26.9489 14 26.75 14L24.365 14C24.2073 13.5656 23.9198 13.1903 23.5414 12.9251C23.163 12.6599 22.7121 12.5176 22.25 12.5176C21.7879 12.5176 21.337 12.6599 20.9586 12.9251C20.5802 13.1903 20.2927 13.5656 20.135 14L13.25 14C13.0511 14 12.8603 14.079 12.7197 14.2197C12.579 14.3603 12.5 14.5511 12.5 14.75C12.5 14.9489 12.579 15.1397 12.7197 15.2803C12.8603 15.421 13.0511 15.5 13.25 15.5L20.135 15.5C20.2927 15.9344 20.5802 16.3097 20.9586 16.5749C21.337 16.8401 21.7879 16.9824 22.25 16.9824C22.7121 16.9824 23.163 16.8401 23.5414 16.5749C23.9198 16.3097 24.2073 15.9344 24.365 15.5ZM21.5 14.75C21.5 14.6017 21.544 14.4567 21.6264 14.3333C21.7088 14.21 21.8259 14.1139 21.963 14.0571C22.1 14.0003 22.2508 13.9855 22.3963 14.0144C22.5418 14.0433 22.6754 14.1148 22.7803 14.2197C22.8852 14.3246 22.9567 14.4582 22.9856 14.6037C23.0145 14.7492 22.9997 14.9 22.9429 15.037C22.8861 15.1741 22.79 15.2912 22.6667 15.3736C22.5433 15.456 22.3983 15.5 22.25 15.5C22.0511 15.5 21.8603 15.421 21.7197 15.2803C21.579 15.1397 21.5 14.9489 21.5 14.75Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div> */}

              {/* mail and notification */}
              {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  position: "relative",
                }}
              >
                <div className="mail_svg_div">
                  <svg
                    width={20}
                    height={21}
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.57864 7.11874L1.57876 7.11888L1.58422 7.11361L7.95301 0.960185C7.95316 0.960043 7.95331 0.9599 7.95346 0.959758C8.46509 0.47353 9.14395 0.202399 9.84979 0.202399C10.5555 0.202399 11.2343 0.47347 11.7459 0.959598C11.7462 0.959794 11.7464 0.959989 11.7466 0.960185L18.114 7.15328C18.1141 7.15345 18.1143 7.15361 18.1145 7.15378C18.3562 7.39365 18.5483 7.67888 18.6796 7.99311C18.8111 8.30756 18.8791 8.64488 18.8799 8.98569V17.7848C18.8694 18.4911 18.5795 19.1644 18.0737 19.6575C17.5677 20.1508 16.8867 20.4234 16.1801 20.4156H16.1784L3.41858 20.4156L3.41693 20.4156C2.71027 20.4234 2.02932 20.1508 1.52327 19.6575C1.01748 19.1644 0.727622 18.4911 0.717108 17.7849V8.9862C0.721131 8.63195 0.799895 8.28254 0.948252 7.96083C1.09672 7.63886 1.31154 7.3519 1.57864 7.11874ZM9.1229 2.21779L9.12285 2.21774L9.11963 2.22086L3.53977 7.63661L3.42918 7.74395L3.53947 7.8516L9.08856 13.2673L9.08851 13.2674L9.09213 13.2707C9.27668 13.4394 9.51768 13.533 9.76773 13.533C10.0178 13.533 10.2588 13.4394 10.4433 13.2707L10.4434 13.2708L10.4463 13.2679L16.0569 7.85217L16.1684 7.74455L16.0572 7.63661L10.4774 2.22086L10.4774 2.22081L10.4741 2.21779C10.2895 2.04908 10.0485 1.95553 9.7985 1.95553C9.54846 1.95553 9.30746 2.04908 9.1229 2.21779ZM17.1282 17.7958L17.1285 17.7958V17.786V9.64181V9.28607L16.8738 9.53441L12.7709 13.5347L12.6598 13.643L12.7719 13.7504L14.4834 15.3902C14.6458 15.5542 14.7368 15.7756 14.7368 16.0063C14.7368 16.2377 14.6453 16.4596 14.4822 16.6237L14.4822 16.6237L14.48 16.626C14.3986 16.7114 14.3008 16.7794 14.1925 16.8261C14.0843 16.8726 13.9678 16.8969 13.8501 16.8974C13.6248 16.8964 13.4086 16.8086 13.2464 16.6522L13.2462 16.6521L11.4307 14.9084L11.3473 14.8282L11.2486 14.8885C10.8212 15.1497 10.3301 15.2879 9.82927 15.2879C9.32844 15.2879 8.83731 15.1497 8.40995 14.8885L8.31125 14.8282L8.22783 14.9084L6.41232 16.6521L6.41213 16.6522C6.24993 16.8086 6.03373 16.8964 5.80847 16.8974C5.6907 16.8969 5.57426 16.8726 5.4661 16.8261C5.35775 16.7794 5.25994 16.7114 5.17855 16.626L5.17857 16.6259L5.17636 16.6237C5.01326 16.4596 4.92171 16.2377 4.92171 16.0063C4.92171 15.7755 5.01285 15.554 5.17527 15.3901L6.87675 13.7501L6.98885 13.642L6.8767 13.534L2.72258 9.53377L2.46853 9.28913V9.64181V17.786H2.46821L2.46885 17.7958C2.48458 18.0358 2.59277 18.2604 2.77069 18.4224C2.94805 18.5838 3.18092 18.6705 3.42061 18.6642H16.1764C16.4161 18.6705 16.649 18.5838 16.8263 18.4224C17.0042 18.2604 17.1124 18.0358 17.1282 17.7958Z"
                      fill="#818181"
                      stroke="white"
                      strokeWidth="0.3"
                    />
                  </svg>
                </div>
                <div>
                  <svg
                    width={25}
                    height={25}
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.3957 13.6249V13.5189V10.2573C18.3943 8.83937 17.8911 7.46774 16.9753 6.38528C16.0596 5.30282 14.7902 4.57937 13.3922 4.34306L13.2672 4.32193V4.19516V3.07713C13.2672 2.84488 13.1749 2.62214 13.0107 2.45791C12.8465 2.29368 12.6237 2.20142 12.3915 2.20142C12.1592 2.20142 11.9365 2.29368 11.7723 2.45791C11.608 2.62214 11.5158 2.84488 11.5158 3.07713V4.19516V4.32193L11.3908 4.34306C9.99271 4.57937 8.72339 5.30282 7.80761 6.38528C6.89185 7.46771 6.38868 8.83927 6.38721 10.2571C6.38721 10.2572 6.38721 10.2572 6.38721 10.2573M18.3957 13.6249L6.23721 10.2571L6.38721 10.2573M18.3957 13.6249L18.4957 13.6603C19.0651 13.8616 19.5583 14.2341 19.9076 14.7267C20.257 15.2193 20.4455 15.8079 20.4472 16.4118V18.4628C20.4472 18.695 20.3549 18.9178 20.1907 19.082C20.0264 19.2462 19.8037 19.3385 19.5714 19.3385H16.3507H16.236L16.206 19.4492C15.9784 20.2865 15.4816 21.0258 14.7922 21.5528C14.1029 22.0798 13.2592 22.3654 12.3915 22.3654C11.5237 22.3654 10.6801 22.0798 9.99071 21.5528C9.30134 21.0258 8.80455 20.2865 8.57698 19.4492L8.54691 19.3385H8.43223H5.2115C4.97925 19.3385 4.75651 19.2462 4.59228 19.082C4.42805 18.9178 4.33579 18.695 4.33579 18.4628V16.4116C4.33753 15.8077 4.52598 15.2192 4.8753 14.7267C5.22466 14.2341 5.71784 13.8616 6.28721 13.6603L6.38721 13.6249V13.5189L6.38721 10.2573M18.3957 13.6249L6.38721 10.2573M16.4943 13.4842H16.6443V13.3342V10.2571C16.6443 9.12918 16.1962 8.04745 15.3987 7.24989C14.6011 6.45233 13.5194 6.00426 12.3915 6.00426C11.2635 6.00426 10.1818 6.45233 9.38426 7.24989C8.5867 8.04745 8.13863 9.12918 8.13863 10.2571V13.3342V13.4842H8.28863H16.4943ZM10.6273 19.3385H10.3674L10.4973 19.5635C10.6894 19.8962 10.9652 20.1729 11.2974 20.366C11.6295 20.5591 12.0064 20.6619 12.3906 20.6642L12.3924 20.6642C12.7766 20.6619 13.1534 20.5591 13.4856 20.366C13.8177 20.1729 14.0935 19.8962 14.2856 19.5635L14.4155 19.3385H14.1557H10.6273ZM18.5457 17.5871H18.6957V17.4371V16.4114C18.6957 16.0995 18.5719 15.8005 18.3514 15.58C18.1309 15.3595 17.8318 15.2357 17.52 15.2357H7.26292C6.9511 15.2357 6.65206 15.3595 6.43157 15.58C6.21108 15.8005 6.08721 16.0995 6.08721 16.4114V17.4371V17.5871H6.23721H18.5457Z"
                      fill="#818181"
                      stroke="white"
                      strokeWidth="0.3"
                    />
                    <circle
                      cx="2.4617"
                      cy="2.4617"
                      r="2.4617"
                      transform="matrix(1 0 0 -1 17.3149 6.56454)"
                      fill="#FF0000"
                    />
                  </svg>
                </div>
              </div> */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  {/* Profile Dropdown */}
                  <IconButton
                    onClick={handleProfileClick}
                    aria-controls="profile-menu"
                    aria-haspopup="true"
                    color="inherit"
                  >
                    {/* <MoreVertIcon /> */}
                    <svg
                      width={35}
                      height={35}
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="17.375"
                        cy="17.375"
                        r="17.375"
                        fill="#F4F4F4"
                      />
                      <mask
                        id="mask0_47_31"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x={8}
                        y={8}
                        width={19}
                        height={19}
                      >
                        <rect
                          x="8.6875"
                          y="8.6875"
                          width="17.375"
                          height="17.375"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_47_31)">
                        <path
                          d="M17.375 17.375C16.5786 17.375 15.8969 17.0915 15.3298 16.5244C14.7627 15.9573 14.4791 15.2755 14.4791 14.4792C14.4791 13.6828 14.7627 13.0011 15.3298 12.434C15.8969 11.8669 16.5786 11.5833 17.375 11.5833C18.1713 11.5833 18.8531 11.8669 19.4202 12.434C19.9873 13.0011 20.2708 13.6828 20.2708 14.4792C20.2708 15.2755 19.9873 15.9573 19.4202 16.5244C18.8531 17.0915 18.1713 17.375 17.375 17.375ZM11.5833 23.1667V21.1396C11.5833 20.7293 11.6889 20.3523 11.9 20.0084C12.1112 19.6645 12.3917 19.4021 12.7416 19.2211C13.4897 18.8471 14.2499 18.5665 15.0221 18.3795C15.7943 18.1925 16.5786 18.099 17.375 18.099C18.1713 18.099 18.9556 18.1925 19.7278 18.3795C20.5001 18.5665 21.2602 18.8471 22.0083 19.2211C22.3582 19.4021 22.6388 19.6645 22.8499 20.0084C23.0611 20.3523 23.1666 20.7293 23.1666 21.1396V23.1667H11.5833Z"
                          fill="#808080"
                        />
                      </g>
                    </svg>
                  </IconButton>
                  <Menu
                    id="profile-menu"
                    className=""
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseProfile}
                  >
                    <Link
                      to="/edit_profile"
                      className="text-decoration-none text-dark"
                    >
                      {" "}
                      <MenuItem onClick={handleCloseProfile}>
                        Edit Profile{" "}
                      </MenuItem>
                    </Link>
                    <Link
                      to="/change_password"
                      className="text-decoration-none text-dark"
                    >
                      {" "}
                      <MenuItem onClick={handleCloseProfile}>
                        Change Password
                      </MenuItem>
                    </Link>
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                  </Menu>
                </div>
              </div>
            </Toolbar>
          </AppBar>
          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                display: { xs: "block", sm: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  backgroundColor: "rgb(47 47 145)",
                },
              }}
            >
              {!isLoginPage && <>{drawer}</>}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                  backgroundColor: "rgb(47 47 145)",
                  height: "100%", // Ensures the drawer takes full height of the screen
                  overflowY: "auto", // Enables scrolling inside the drawer if content overflows
                  /* Custom scrollbar styling */
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    borderRadius: "8px", // Thumb roundness
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888", // Thumb color
                    borderRadius: "8px", // Thumb roundness
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                  scrollbarWidth: "thin",
                  scrollbarColor: "#ffffff #cfc9c9",
                },
              }}
              open
            >
              {!isLoginPage && <>{drawer}</>}
            </Drawer>
          </Box>
        </>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {!isLoginPage && (
          <>
            <Toolbar />
          </>
        )}
        <Routing />
      </Box>
    </Box>
  );
}
